import {
    MobileOutlined,
    CodeOutlined,
    TeamOutlined,
    AppstoreOutlined,
    MessageOutlined,
    UserOutlined,
    NotificationOutlined,
    ShopOutlined,
} from '@ant-design/icons';
import React from 'react';

export const socialAppDetail = {
    title: 'Social App - Ứng dụng mạng xã hội di động',
    description: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Tổng quan</h2>
            <p className="mb-4">
                Social App là một ứng dụng mạng xã hội di động được phát triển theo nhóm 5 người trong khuôn khổ môn học
                Phát triển ứng dụng đa nền tảng. Dự án này là bản clone của Facebook với đầy đủ các tính năng cơ bản của
                một mạng xã hội hiện đại, kèm theo tính năng mới là hệ thống xu - cho phép người dùng thưởng xu cho
                những bài viết chất lượng và trừ xu cho những bài viết không phù hợp.
            </p>
            <p className="mb-4">
                Ứng dụng được xây dựng bằng React Native với Expo, kết hợp Redux Toolkit để quản lý state. Trong quá
                trình phát triển, nhóm đã áp dụng quy trình Agile để đảm bảo tiến độ và chất lượng sản phẩm.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Các đặc điểm nổi bật</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h4 className="font-semibold text-blue-700 mb-2">Bảng tin tương tác</h4>
                    <p className="text-sm text-gray-700">
                        Hiển thị bài viết từ bạn bè và người dùng khác, cho phép tương tác qua like, comment và hệ thống
                        xu.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-semibold text-green-700 mb-2">Hệ thống xu độc đáo</h4>
                    <p className="text-sm text-gray-700">
                        Cơ chế tặng và trừ xu giúp khuyến khích nội dung chất lượng, tạo sự khác biệt so với các mạng xã
                        hội khác.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h4 className="font-semibold text-purple-700 mb-2">Nhắn tin trực tiếp</h4>
                    <p className="text-sm text-gray-700">
                        Hệ thống chat riêng tư giữa người dùng, hỗ trợ gửi tin nhắn văn bản và hình ảnh.
                    </p>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500">
                    <h4 className="font-semibold text-amber-700 mb-2">Trải nghiệm native-like</h4>
                    <p className="text-sm text-gray-700">
                        Giao diện mượt mà, phản hồi nhanh và trải nghiệm giống ứng dụng native trên cả iOS và Android.
                    </p>
                </div>
            </div>
        </>
    ),
    technologies: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Công nghệ sử dụng</h2>

            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <MobileOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Frontend & Mobile</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/react-native.png" alt="React Native" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">React Native</span>
                                <span className="text-xs text-gray-500 mt-1">Framework</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/expo.svg" alt="Expo" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Expo</span>
                                <span className="text-xs text-gray-500 mt-1">Development Platform</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/redux.svg" alt="Redux Toolkit" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Redux Toolkit</span>
                                <span className="text-xs text-gray-500 mt-1">State Management</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Tools & Development</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/git.png" alt="Git" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Git</span>
                                <span className="text-xs text-gray-500 mt-1">Version Control</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vscode.jpeg" alt="VS Code" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">VS Code</span>
                                <span className="text-xs text-gray-500 mt-1">Code Editor</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/agile.png" alt="Agile" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Agile</span>
                                <span className="text-xs text-gray-500 mt-1">Development Methodology</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    features: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Tính năng chính</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <AppstoreOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Bảng tin & Bài viết</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tạo và chia sẻ bài viết</span> với văn bản và
                                        hình ảnh
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tương tác</span> qua like, comment và tặng/trừ
                                        xu
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Newsfeed thông minh</span> hiển thị bài viết từ
                                        bạn bè và nội dung phổ biến
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4 grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/social-app/danh-sach-bai-viet.jpg"
                                alt="Danh sách bài viết"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/social-app/chi-tiet-bai-viet.jpg"
                                alt="Chi tiết bài viết"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <ShopOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Hệ thống xu</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tặng xu</span> cho các bài viết chất lượng, hữu
                                        ích
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Trừ xu</span> cho bài viết kém chất lượng, không
                                        phù hợp
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Cửa hàng xu</span> với các phần thưởng và tính
                                        năng đặc biệt
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4 grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/social-app/cua-hang-xu.jpg"
                                alt="Cửa hàng xu"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/social-app/tao-bai-viet.jpg"
                                alt="Tạo bài viết"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <TeamOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Kết nối & Bạn bè</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Kết bạn</span> và quản lý danh sách bạn bè
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Gợi ý bạn bè</span> dựa trên mối quan hệ chung
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Chặn người dùng</span> không mong muốn
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4 grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/social-app/danh-sach-ban-be.jpg"
                                alt="Danh sách bạn bè"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/social-app/goi-y-ban-be.jpg"
                                alt="Gợi ý bạn bè"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <MessageOutlined className="text-amber-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Nhắn tin & Tương tác</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Nhắn tin trực tiếp</span> với bạn bè và liên hệ
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Chia sẻ hình ảnh</span> và nội dung đa phương
                                        tiện
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Thông báo</span> về tin nhắn mới và tương tác
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4 grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/social-app/danh-sach-tin-nhan.jpg"
                                alt="Danh sách tin nhắn"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/social-app/cai-dat-thong-bao.jpg"
                                alt="Cài đặt thông báo"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 mb-6">
                <div className="bg-gradient-to-r from-blue-500 to-cyan-500 px-6 py-4 flex items-center">
                    <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                        <UserOutlined className="text-blue-600 text-xl" />
                    </div>
                    <h3 className="text-xl font-bold text-white">Hồ sơ & Cài đặt</h3>
                </div>

                <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Trang cá nhân</span> với thông tin người dùng,
                                        bài viết và hoạt động
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Cập nhật ảnh đại diện</span> và thông tin cá
                                        nhân
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Quản lý quyền riêng tư</span> và cài đặt tài
                                        khoản
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/social-app/trang-ca-nhan.jpg"
                                alt="Trang cá nhân"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/social-app/tai-anh-dai-dien.jpg"
                                alt="Tải ảnh đại diện"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    results: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết quả đạt được</h2>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-blue-600 font-bold text-xl">A</span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Điểm số môn học</h3>
                        <p className="text-gray-700">
                            Dự án đạt điểm cao trong môn học Phát triển ứng dụng đa nền tảng
                        </p>
                    </div>

                    <div className="bg-green-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-green-600 font-bold text-xl">5</span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Kinh nghiệm nhóm</h3>
                        <p className="text-gray-700">
                            Phát triển kỹ năng làm việc nhóm, quản lý dự án và phát triển ứng dụng di động
                        </p>
                    </div>

                    <div className="bg-purple-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-purple-600 font-bold text-xl">✓</span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Hoàn thiện tính năng</h3>
                        <p className="text-gray-700">
                            Ứng dụng hoàn thiện với đầy đủ các tính năng dự kiến, hoạt động ổn định trên nhiều thiết bị
                        </p>
                    </div>
                </div>
            </div>
        </>
    ),
    screenshots: [
        {
            url: '/assets/images/projects/social-app/dang-nhap.jpg',
            caption: 'Màn hình đăng nhập',
        },
        {
            url: '/assets/images/projects/social-app/danh-sach-bai-viet.jpg',
            caption: 'Danh sách bài viết',
        },
        {
            url: '/assets/images/projects/social-app/chi-tiet-bai-viet.jpg',
            caption: 'Chi tiết bài viết',
        },
        {
            url: '/assets/images/projects/social-app/cua-hang-xu.jpg',
            caption: 'Cửa hàng xu',
        },
        {
            url: '/assets/images/projects/social-app/danh-sach-ban-be.jpg',
            caption: 'Danh sách bạn bè',
        },
        {
            url: '/assets/images/projects/social-app/goi-y-ban-be.jpg',
            caption: 'Gợi ý bạn bè',
        },
        {
            url: '/assets/images/projects/social-app/danh-sach-tin-nhan.jpg',
            caption: 'Danh sách tin nhắn',
        },
        {
            url: '/assets/images/projects/social-app/trang-ca-nhan.jpg',
            caption: 'Trang cá nhân',
        },
        {
            url: '/assets/images/projects/social-app/tai-anh-dai-dien.jpg',
            caption: 'Tải ảnh đại diện',
        },
        {
            url: '/assets/images/projects/social-app/tao-bai-viet.jpg',
            caption: 'Tạo bài viết',
        },
        {
            url: '/assets/images/projects/social-app/cai-dat-thong-bao.jpg',
            caption: 'Cài đặt thông báo',
        },
        {
            url: '/assets/images/projects/social-app/danh-sach-chan-nguoi-dung.jpg',
            caption: 'Danh sách chặn người dùng',
        },
        {
            url: '/assets/images/projects/social-app/nhat-ky-hoat-dong-tim-kiem.jpg',
            caption: 'Nhật ký hoạt động tìm kiếm',
        },
        {
            url: '/assets/images/projects/social-app/danh-sach-chuc-nang.jpg',
            caption: 'Danh sách chức năng',
        },
    ],
    teamSize: 5,
    duration: '2 tháng',
    role: 'Mobile Developer',
    architecture: 'React Native + Redux',
    responsibilities: [
        'Phát triển giao diện người dùng với React Native',
        'Quản lý state ứng dụng với Redux Toolkit',
        'Xây dựng tính năng hệ thống xu và tương tác bài viết',
        'Tích hợp React Navigation cho điều hướng trong ứng dụng',
        'Tối ưu hiệu suất ứng dụng trên cả iOS và Android',
        'Phối hợp làm việc nhóm theo quy trình Agile',
    ],
};
